// Admin Dashboard Constants

export const USER_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'suspended', label: 'Suspended' }
];

export const ROLE_OPTIONS = [
  { value: 'user', label: 'User' },
  { value: 'admin', label: 'Admin' }
];

export const SHIFT_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'expired', label: 'Expired' },
  { value: 'deleted', label: 'Deleted' }
];

export const DRIVER_POST_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'expired', label: 'Expired' },
  { value: 'deleted', label: 'Deleted' }
];

export const AUDIT_ACTIONS = [
  { value: 'create', label: 'Create' },
  { value: 'update', label: 'Update' },
  { value: 'delete', label: 'Delete' }
];

export const MEDALLION_POST_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'expired', label: 'Expired' },
  { value: 'deleted', label: 'Deleted' }
];

export const AUDIT_ENTITY_TYPES = [
  { value: 'user', label: 'User' },
  { value: 'shift', label: 'Car Listing' },
  { value: 'driver_post', label: 'Driver Listing' },
  { value: 'medallion_post', label: 'Medallion Listing' }
];

export const AD_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'paused', label: 'Paused' },
  { value: 'expired', label: 'Expired' }
];

export const AD_TARGET_PAGES = [
  { value: 'dashboard', label: 'Dashboard' },
  { value: 'medallions', label: 'Medallions' },
  { value: 'both', label: 'Both' }
];

export const PAGE_SIZES = [10, 25, 50, 100];
export const DEFAULT_PAGE_SIZE = 20;
